module.exports = "/src/views/donate/sapper/images/logo-sapper.png";